"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- HEADER : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'Header',
  group: _definitionhelpers.groupNames.structures,
  props: {
    content: {
      type: 'object',
      default: _react.default.createElement("h1", null, "This is a Header")
    },
    logo: {
      type: 'object',
      default: {
        type: 'internal',
        action: 'dashboard/home'
      }
    }
  }
};
exports.default = _default;